import { useEffect, useState } from "react";

/** Whether to show ⌘ rather than Ctrl in keyboard hints. Defaults to Mac until mounted. */
export function useIsMac(): boolean {
  const [isMac, setIsMac] = useState(true);

  useEffect(() => {
    const platform =
      (navigator as { userAgentData?: { platform?: string } }).userAgentData
        ?.platform || navigator.platform || "";
    setIsMac(/mac/i.test(platform));
  }, []);

  return isMac;
}
